/* eslint-disable react-hooks/exhaustive-deps */
/**
 * @see https://imask.js.org/guide.html
 */
import React, { useEffect, useRef } from 'react'
import { IMaskMixin } from 'react-imask'
import InputBase from '../InputBase'
import PropTypes from 'prop-types'
import { useField } from '@unform/core'

const InputMaskedBase = IMaskMixin(
  ({ inputRef: ref, ...props }) => {
    const inputElementRef = useRef(null)
    const maskRef = useRef(null)

    useEffect(() => {
      if (maskRef.current && inputElementRef.current) {
        const { value } = inputElementRef.current
        maskRef.current.updateValue(value)
      }
    }, [])

    useEffect(() => {
      if (inputElementRef.current && maskRef.current) {
        const { value } = inputElementRef.current
        maskRef.current.updateValue(value)
      }
    }, [])

    const handleMaskRef = (mask) => {
      maskRef.current = mask
    }

    return (
      <InputBase
        {...props}
        ref={ref}
        onMask={handleMaskRef}
        onChange={(e) => {
          if (maskRef.current && inputElementRef.current) {
            const { value } = e.target
            maskRef.current.updateValue(value)
          }
        }}
        inputRef={(element) => {
          ref(element)
          inputElementRef.current = element
        }}
      />
    )
  }
)

const InputMasked = ({
  name,
  uppercase,
  prepare,
  onChangeValue,
  base,
  value,
  renderKey,
  ...props
}) => {
  const { fieldName, defaultValue = '', error, registerField } = useField(name)

  const inputRef = useRef(null)

  const handleChange = React.useCallback(
    (value, masked) => {
      let formattedValue = props.unmask ? masked.masked.unmaskedValue : value

      if (base === 'cents') {
        // O "* 1000 / 10" e "Math.round" são pra contornar um um bug do interpretador onde 2.3 * 100 = 229.9999[...]7
        formattedValue = Math.round(
          (Number(formattedValue.replace(',', '.')) * 1000) / 10 // !!!! NÃO MEXA AQUI !!!!
        )
      }

      /*
       * If you use a setState it triggers unwanted DOM updates wich makes
       * the input unmutable due to the defaultValue been set every time
       */

      if (inputRef.current?.element) {
        inputRef.current.element.dataset.formattedValue = formattedValue
      }

      onChangeValue(formattedValue)
    },
    [props.unmask, base, onChangeValue]
  )

  useEffect(() => {
    registerField({
      ref: inputRef.current?.element,
      name: fieldName,
      path: 'value',
      getValue (input) {
        return input?.dataset?.formattedValue
      }
    })
  }, [registerField, fieldName, inputRef])

  return (
    <InputMaskedBase
      {...props}
      ref={inputRef}
      defaultValue={defaultValue}
      name={name}
      error={error}
      onAccept={handleChange}
      data-formatted-value={defaultValue}
      prepare={(value, ...args) =>
        prepare(uppercase ? value.toUpperCase() : value, ...args)
      }
    />
  )
}

InputMasked.defaultProps = {
  unmask: true,
  uppercase: false,
  base: '',
  prepare: (val) => val,
  onChangeValue: () => {}
}

InputMasked.propTypes = {
  mask: PropTypes.any.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  value: PropTypes.any,
  unmask: PropTypes.bool,
  uppercase: PropTypes.bool,
  prepare: PropTypes.func,
  onChangeValue: PropTypes.func,
  base: PropTypes.string,
  renderKey: PropTypes.any
}

export default InputMasked
